export default __webpack_public_path__ + "6f6c49f1a3a12afc4dd9bca0bb636bb3.svg";